/**
 * @generated SignedSource<<668b3edf93002cfe526b15e75a40b23c>>
 * @relayHash 0da891ebc91832bab75be58319e47f10
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID dcb0effecbd4ee333f8bbc40dbf593d0618ba3236edd5007050f7f719441833d

import type { ConcreteRequest } from 'relay-runtime';
export type CommentCreationLocation = "DATABASE" | "EDITOR" | "LIVE" | "RENDERER" | "SLIDE" | "WHITEBOARD" | "%future added value";
export type ContentRepresentation = "ATLAS_DOC_FORMAT" | "EDITOR" | "EDITOR2" | "EXPORT_VIEW" | "PLAIN" | "RAW" | "STORAGE" | "STYLED_VIEW" | "VIEW" | "WIKI" | "%future added value";
export type Platform = "ANDROID" | "IOS" | "WEB" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type ReplyInlineCommentInput = {
  commentBody: CommentBody;
  commentSource?: Platform | null;
  containerId: string;
  createdFrom?: CommentCreationLocation | null;
  parentCommentId: string;
};
export type CommentBody = {
  representationFormat: ContentRepresentation;
  value: string;
};
export type CommentRepliesCreateInlineReplyMutation$variables = {
  includeReactions: boolean;
  input: ReplyInlineCommentInput;
  pageId: string;
};
export type CommentRepliesCreateInlineReplyMutation$data = {
  readonly replyInlineComment: {
    readonly author: {
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly permissionType: SitePermissionType | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
    };
    readonly body: {
      readonly value: string;
    };
    readonly contentStatus: string;
    readonly createdAt: {
      readonly value: string;
    };
    readonly createdAtNonLocalized: string;
    readonly id: string;
    readonly links: {
      readonly editui: string | null;
      readonly webui: string | null;
    };
    readonly location: {
      readonly commentResolveProperties?: {
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null;
        readonly resolvedTime: AGG$Long | null;
        readonly resolvedUser: string | null;
      } | null;
      readonly inlineMarkerRef?: string | null;
      readonly inlineResolveProperties?: {
        readonly isDangling: boolean;
        readonly resolved: boolean;
        readonly resolvedFriendlyDate: string | null;
        readonly resolvedTime: AGG$Long | null;
        readonly resolvedUser: string | null;
      } | null;
      readonly inlineText?: string | null;
      readonly type: string;
    };
    readonly parentId: string | null;
    readonly permissions: {
      readonly isEditable: boolean;
      readonly isRemovable: boolean;
      readonly isResolvable: boolean;
    };
    readonly reactionsSummary?: {
      readonly ari: string;
      readonly containerAri: string;
      readonly reactionsCount: number;
      readonly reactionsSummaryForEmoji: ReadonlyArray<{
        readonly count: number;
        readonly emojiId: string;
        readonly id: string;
        readonly reacted: boolean;
      } | null>;
    } | null;
    readonly version: {
      readonly by: {
        readonly displayName: string | null;
      } | null;
      readonly number: number | null;
      readonly when: string | null;
    };
  } | null;
};
export type CommentRepliesCreateInlineReplyMutation = {
  response: CommentRepliesCreateInlineReplyMutation$data;
  variables: CommentRepliesCreateInlineReplyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeReactions"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pageId"
},
v3 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "kind": "ScalarField",
    "name": "value"
  }
],
v6 = {
  "args": [
    {
      "kind": "Literal",
      "name": "representation",
      "value": "ATLAS_DOC_FORMAT"
    }
  ],
  "concreteType": "DocumentBody",
  "kind": "LinkedField",
  "name": "body",
  "plural": false,
  "selections": (v5/*: any*/),
  "storageKey": "body(representation:\"ATLAS_DOC_FORMAT\")"
},
v7 = {
  "kind": "ScalarField",
  "name": "contentStatus"
},
v8 = {
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdAt",
  "plural": false,
  "selections": (v5/*: any*/)
},
v9 = {
  "kind": "ScalarField",
  "name": "createdAtNonLocalized"
},
v10 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    },
    {
      "kind": "ScalarField",
      "name": "editui"
    }
  ]
},
v11 = {
  "kind": "ScalarField",
  "name": "type"
},
v12 = {
  "kind": "ScalarField",
  "name": "resolved"
},
v13 = {
  "kind": "ScalarField",
  "name": "resolvedFriendlyDate"
},
v14 = {
  "kind": "ScalarField",
  "name": "resolvedTime"
},
v15 = {
  "kind": "ScalarField",
  "name": "resolvedUser"
},
v16 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "inlineMarkerRef"
    },
    {
      "kind": "ScalarField",
      "name": "inlineText"
    },
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "inlineResolveProperties",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        {
          "kind": "ScalarField",
          "name": "isDangling"
        },
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "type": "InlineComment"
},
v17 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "concreteType": "InlineCommentResolveProperties",
      "kind": "LinkedField",
      "name": "commentResolveProperties",
      "plural": false,
      "selections": [
        (v12/*: any*/),
        (v13/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/)
      ]
    }
  ],
  "type": "FooterComment"
},
v18 = {
  "kind": "ScalarField",
  "name": "parentId"
},
v19 = {
  "concreteType": "CommentPermissions",
  "kind": "LinkedField",
  "name": "permissions",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isEditable"
    },
    {
      "kind": "ScalarField",
      "name": "isRemovable"
    },
    {
      "kind": "ScalarField",
      "name": "isResolvable"
    }
  ]
},
v20 = {
  "kind": "ScalarField",
  "name": "displayName"
},
v21 = {
  "kind": "ScalarField",
  "name": "when"
},
v22 = {
  "kind": "ScalarField",
  "name": "number"
},
v23 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "profilePicture",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "path"
    }
  ]
},
v24 = {
  "kind": "ScalarField",
  "name": "permissionType"
},
v25 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "accountId"
    }
  ],
  "type": "KnownUser"
},
v26 = {
  "condition": "includeReactions",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "childType",
          "value": "comment"
        },
        {
          "kind": "Literal",
          "name": "contentType",
          "value": "page"
        },
        {
          "kind": "Variable",
          "name": "pageId",
          "variableName": "pageId"
        }
      ],
      "concreteType": "ReactionsSummaryResponse",
      "kind": "LinkedField",
      "name": "reactionsSummary",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "ari"
        },
        {
          "kind": "ScalarField",
          "name": "containerAri"
        },
        {
          "kind": "ScalarField",
          "name": "reactionsCount"
        },
        {
          "concreteType": "ReactionsSummaryForEmoji",
          "kind": "LinkedField",
          "name": "reactionsSummaryForEmoji",
          "plural": true,
          "selections": [
            (v4/*: any*/),
            {
              "kind": "ScalarField",
              "name": "emojiId"
            },
            {
              "kind": "ScalarField",
              "name": "count"
            },
            {
              "kind": "ScalarField",
              "name": "reacted"
            }
          ]
        }
      ]
    }
  ]
},
v27 = {
  "kind": "ScalarField",
  "name": "__typename"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Fragment",
    "name": "CommentRepliesCreateInlineReplyMutation",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replyInlineComment",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              (v11/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ]
          },
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                  (v20/*: any*/)
                ]
              },
              (v21/*: any*/),
              (v22/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v20/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/)
            ]
          },
          (v26/*: any*/)
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CommentRepliesCreateInlineReplyMutation",
    "selections": [
      {
        "args": (v3/*: any*/),
        "concreteType": "Comment",
        "kind": "LinkedField",
        "name": "replyInlineComment",
        "plural": false,
        "selections": [
          (v4/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          {
            "kind": "LinkedField",
            "name": "location",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              (v11/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/)
            ]
          },
          (v18/*: any*/),
          (v19/*: any*/),
          {
            "concreteType": "Version",
            "kind": "LinkedField",
            "name": "version",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "name": "by",
                "plural": false,
                "selections": [
                  (v27/*: any*/),
                  (v20/*: any*/)
                ]
              },
              (v21/*: any*/),
              (v22/*: any*/)
            ]
          },
          {
            "kind": "LinkedField",
            "name": "author",
            "plural": false,
            "selections": [
              (v27/*: any*/),
              (v20/*: any*/),
              (v23/*: any*/),
              (v24/*: any*/),
              (v25/*: any*/)
            ]
          },
          (v26/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "cacheID": "0da891ebc91832bab75be58319e47f10",
    "id": "dcb0effecbd4ee333f8bbc40dbf593d0618ba3236edd5007050f7f719441833d",
    "metadata": {},
    "name": "CommentRepliesCreateInlineReplyMutation",
    "operationKind": "mutation",
    "text": "mutation CommentRepliesCreateInlineReplyMutation($input:ReplyInlineCommentInput!,$pageId:ID!,$includeReactions:Boolean!){replyInlineComment(input:$input){id,body(representation:ATLAS_DOC_FORMAT){value},contentStatus,createdAt{value},createdAtNonLocalized,links{webui,editui},location{__typename,type,...on InlineComment{inlineMarkerRef,inlineText,inlineResolveProperties{resolved,isDangling,resolvedFriendlyDate,resolvedTime,resolvedUser}},...on FooterComment{commentResolveProperties{resolved,resolvedFriendlyDate,resolvedTime,resolvedUser}}},parentId,permissions{isEditable,isRemovable,isResolvable},version{by{__typename,displayName},when,number},author{__typename,displayName,profilePicture{path},permissionType,...on KnownUser{accountId}},reactionsSummary(pageId:$pageId,contentType:\"page\",childType:\"comment\")@include(if:$includeReactions){ari,containerAri,reactionsCount,reactionsSummaryForEmoji{id,emojiId,count,reacted}}}}"
  }
};
})();

(node as any).hash = "3ec5c8e50962a5f1e44c0682ca61f71f";

export default node;
